import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
  fallback?: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ 
  children, 
  redirectTo = '/login',
  fallback 
}) => {
  const { t } = useTranslation();
  const { user, token } = useAuth();
  const location = useLocation();

  // Si no hay token, redirigir al login
  if (!token) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // Si no hay usuario pero hay token, mostrar fallback o loading
  if (!user) {
    return fallback || (
      <div style={{ padding: 20, textAlign: 'center' }}>
        {t('loading')}...
      </div>
    );
  }

  // Usuario autenticado
  return <>{children}</>;
};

export default PrivateRoute; 